import { render } from "./SideBarTitle.vue?vue&type=template&id=74dccd2f&scoped=true"
import script from "./SideBarTitle.vue?vue&type=script&lang=js"
export * from "./SideBarTitle.vue?vue&type=script&lang=js"

import "./SideBarTitle.vue?vue&type=style&index=0&id=74dccd2f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74dccd2f"]])

export default __exports__